import { FC, memo, PropsWithChildren } from 'react';

import { dom } from 'app/utils';
import { Button, IButton } from '../common';
import { IInput } from './types';

export interface IItem extends PropsWithChildren<IInput> {
  onRemove?: (value?: any) => void;
}

export const Item: FC<IItem> = memo(({ id, className, style, readOnly, disabled, value, invalid, children, onRemove }) => {
  const item: any = { id, style,
    className: dom.className('i-component', 'i-item', { 'i-invalid': invalid }, className),
  };

  const remove: IButton = { icon: 'mdi-delete', severity: 'danger', text: true, rounded: true,
    disabled: (disabled || !value),

    onClick: dom.handle(onRemove, () => value),
  };

  return (
    <div { ...item }>
      <div className="i-body">
        { children }
      </div>
      {!readOnly && <Button { ...remove } />}
    </div>
  );
});
